<template>

  <div>
    <div class="poi-header-wrapper">
      <img :src="group.getIconUrl() ?? group.getIconUrl()" class="max-h-66 poi-icon" />
    </div>

    <div class="poi-title-wrapper">
      <div class="flex justify-between items-center">
        <div class="poi-title">{{ group.getName(language) }}</div>
      </div>
    </div>

    <div class="poi-description-wrapper mt-[20px]">
      <div class="poi-description-value" v-if="!!group.getDescription(language)" v-html="group.getDescription(language)"></div>
    </div>
  </div>

</template>
<script>
import { mapState } from 'vuex';

export default {
    computed: {
		...mapState('wf', ['language']),
	},
    props: {
      group: {
      default: null,
      type: Object
    },
  },
}
</script>


<style lang="postcss">


</style>
